import * as actionTypes from './actionTypes';

const filterValues = (filter: object) => ({
  type: actionTypes.FILTER_VALUES,
  filter
});

export const registerFilterValues = (filter: object) => {
  return (dispatch, getState) => {
    const state = getState();
    const isNotRangeError = !state.validationDateRange.error;
    isNotRangeError && dispatch(filterValues(filter));
  };
};
